import { Component, OnInit } from "@angular/core";
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { PtImageMappingService } from '../../../service/pt-image-mapping.service';
import { Router } from '@angular/router';
import { AppConfigService } from 'app-config';
import { ConstantService } from './../../../service/constant.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.states';
import { getUserState$ } from '@modules/store/user-store/selectors';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { CapHeaderService, CapHeaderViewPermissions, CapHeaderUserInfoData } from '@cap/cap-ui';

@Component({
    selector: 'app-pt-image-mapping',
    templateUrl: './pt-image-mapping.component.html',
    styleUrls: ['./pt-image-mapping.component.scss'],
})
export class PtImageMappingComponent implements OnInit {

    public staffURL = AppConfigService.settings.apiServer.staffHome;
    public capOrgURL = AppConfigService.settings.apiServer.capOrg;
    public isActiveBasic: boolean = true;
    public mailingForm: FormGroup;
    public mailingYearForm: FormGroup;
    public anatomicSiteForm: FormGroup;
    public caseImageMappingForm: FormGroup;
    public mailingYears: Array<object> = [];
    public mailingMappedImages: Array<object> = [];
    public anatomicSiteDesc: Array<object> = [];
    public primaryDiagnosisList: Array<object> = [];
    public caseDropDownList: Array<object> = [];
    public slideTypeList: Array<object> = [];
    public mailingValidation: boolean = false;
    public mailingMappedValidation: boolean = false;
    public caseImageMappingValidation: boolean = false;
    public anatomicSiteNoValidation: boolean = false;
    public isCommitteeMember: boolean;
    public isCAPStaff: boolean;
    public isCombinedCallLoaded: boolean = false;

    constructor(private ptImageMappingService: PtImageMappingService, private router: Router, private constantService: ConstantService, private store$: Store<AppState>, private capHeaderService: CapHeaderService) {
    }

    ngOnInit(): void {
        // CREATE FORM FOR MAILING ID
        this.mailingForm = new FormGroup({
            mailing: new FormControl('', [Validators.required])
        });

        // CREATE FORM FOR MAILING YEAR
        this.mailingYearForm = new FormGroup({
            year: new FormControl('', [Validators.required]),
            mappedImages: new FormControl('', [Validators.required])
        });

        // CREATE FORM FOR ANATOMIC SITE
        this.anatomicSiteForm = new FormGroup({
            site: new FormControl('', [Validators.required]),
            site_no: new FormControl('', [Validators.required])
        });

        // CREATE FORM FOR CASE
        this.caseImageMappingForm = new FormGroup({
            case: new FormControl('', [Validators.required])
        });

        // SERVICE CALL TO GET THE MAILLING YEAR DROPDOWN
        const currentYear = new Date();
        this.mailingYears.push(
            { currentYear: false, year: currentYear.getFullYear() - 1 },
            { currentYear: true, year: currentYear.getFullYear()},
            { currentYear: false, year: currentYear.getFullYear() + 1 },
            { currentYear: false, year: currentYear.getFullYear() + 2 }
        );

        const selectedYear: any = this.mailingYears[1];
        this.mailingYearForm.controls['year'].setValue(selectedYear.year);
        localStorage.setItem('specimen-year', selectedYear.year);

        // Not used after implement forkJoin kept for reference
        this.getAnatomicSite();

        this.ptImageMappingService.getAllMailAccessAnatomicCall(selectedYear.year,this.store$).subscribe((resCombined) => {

            this.isCAPStaff = this.constantService.getCAPStaffPermision();
            this.isCommitteeMember = this.constantService.getCommitteeMemberPermision();
            // DISABLE CASE FORM ON INITIAL LOAD. - IF CAP STAFF MEMBER
            this.disableCaseForm((this.isCAPStaff) ? true : false);

            this.isCombinedCallLoaded = true;
            this.mailingMappedImages = resCombined[1];
            this.anatomicSiteDesc = resCombined[2];
        });

    }

    disableCaseForm = disabled => {
        if (disabled) {
            this.mailingForm.get('mailing').enable();
            this.mailingYearForm.get('year').enable();
            this.mailingYearForm.get('mappedImages').enable();

            this.anatomicSiteForm.get('site').disable();
            this.anatomicSiteForm.get('site_no').disable();
            this.caseImageMappingForm.get('case').disable();

        } else {
            this.anatomicSiteForm.get('site').enable();
            this.anatomicSiteForm.get('site_no').enable();
            this.caseImageMappingForm.get('case').enable();

            this.mailingForm.get('mailing').disable();
            this.mailingYearForm.get('year').disable();
            this.mailingYearForm.get('mappedImages').disable();

        }
    }

    // GET MAPPED IMAGES BASED ON YEAR.
    getMappedImagesOnYear = year => {
        this.ptImageMappingService.getMappedImages(year).subscribe((result) => {
            this.mailingMappedImages = result
        });
    }

    // CHANGE YEAR EVENT
    onChangeYear = (event) => {
        localStorage.setItem('specimen-year', event.target.value);
        this.getMappedImagesOnYear(event.target.value);
    }

    // MAILING FORM SUBMIT
    mailingFormSubmit = () => {
        // SERVICE CALL TO CHECK VALID MALLING ID AND NAVIGATE TO SPECIMEN PAGE.
        this.ptImageMappingService.mailingSearch(this.mailingForm.value.mailing).subscribe(result => {
            if (result) {
                this.mailingValidation = false;
                this.router.navigateByUrl('mailing/' + this.mailingForm.value.mailing + '/images');
            } else {
                this.mailingValidation = true;
            }
        });
    }

    // MAILING YEAR FORM SUBMIT
    mailingYearFormSubmit = () => {
        // SERVICE CALL TO NAVIGATE THE SPECIMEN RESULT PAGE.
        this.ptImageMappingService.mailingSearch(this.mailingYearForm.value.mappedImages).subscribe(result => {
            if (result) {
                this.mailingMappedValidation = false;
                localStorage.setItem('resetSearch', JSON.stringify({ year: this.mailingYearForm.value.year, mailingID: this.mailingYearForm.value.mappedImages }));
                this.router.navigateByUrl('mailing/' + this.mailingYearForm.value.mappedImages + '/images');
            } else {
                this.mailingMappedValidation = true;
            }
        });
    }

    // SERVICE CALL TO GET ANATOMIC SITE CODE AND DESC.
    getAnatomicSite = () => {
        this.ptImageMappingService.getAnatomicSite().subscribe(result => {
            this.anatomicSiteDesc = result;
        });
    }

    onChangeAnatomicSite = (event) => {
        this.anatomicSiteForm.controls['site_no'].setValue(event.target.value);
    }
    // ON CHANGE EVENT SET ANATOMICE SITE CODE.
    onKeyUpSelectAnatomicSite = event => {
        const siteDesc:any = this.anatomicSiteDesc.find( (item:any) => item.code == event.target.value);
        if(siteDesc && siteDesc.code){
            this.anatomicSiteForm.controls['site'].setValue(siteDesc.code);
        }
    }

    // TO SUBMIT ANATOMIC SITE FORM AND VALIDATE THE SITE NO. AND NAVIGATE THE TO ANATOMIC SITE PAGE.
    anatomicSiteFormSubmit = () => {
        this.ptImageMappingService.caseImageMapping(this.anatomicSiteForm.value.site_no).subscribe(result => {
            if (result ?.length > 0) {
                this.router.navigateByUrl('/anatomic-site/' + this.anatomicSiteForm.value.site_no + '/images');
                this.anatomicSiteNoValidation = false;
            } else {
                this.anatomicSiteNoValidation = true;
            }
        });
    }

    // TO SUBMIT CASE NUMBER FORM AND VALIDATE THE NUMBER AND NAVIGATE TO CASE RESULT PAGE.
    caseImageMappingFormSubmit = () => {
        this.ptImageMappingService.caseMailMappingImage(this.caseImageMappingForm.value.case).subscribe(result => {
            if (result) {
                this.caseImageMappingValidation = false;
                this.router.navigateByUrl('/case/' + this.caseImageMappingForm.value.case + '/images');
            } else {
                this.caseImageMappingValidation = true;
            }
        }, error => {
            if(error != null){
                this.caseImageMappingValidation = true;
            }
        });
    }
}